

















































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { UserProfile } from '../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import { ResumeWrapper } from '../models/jobs/resumeWrapper';
import { Resume } from '../models/jobs/resume';
import { ResumeRecord } from '../models/jobs/resumerecord';
import { ResumePayload } from '../models/jobs/resumepayload';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import UploadResumeSection from '@/components/Commons/UploadResumeSection.vue';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});
declare var window: any;

@Component({
  name: 'ResumeDetails',
  components: {
    Datepicker,
    UploadResumeSection,
    ProfilePlaceholder,
  },
})
export default class ResumeDetails extends Mixins(GuidedSignupUtilities) {
  $wlToastr: any;
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  private resumePayload: ResumePayload = new ResumePayload();
  private currentResumeName: string = '';
  private currentResume: ResumeRecord = new ResumeRecord();
  private selectedResume: ResumeRecord = new ResumeRecord();
  private errorString: string = '';
  private enableUploadResumeBtn = true;
  //new variables
  private showUploadText: boolean = true;
  private resumeAvailable: boolean = false;
  private selectedNewResume: ResumeRecord = new ResumeRecord();
  private supportedFileSize = 0;

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop() isRequiredStep;
  @Prop() minimumEntries;



  @Watch('resumeListing')
  resumeListingUpdated(newList, oldList) {
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep
      ? newList.resumes.length < this.minimumEntries : this.isRequiredStep) : newList.resumes.length === 0;
    this.$emit('disable-next-button', disable);
  }
  get sectionSubHeader() {
    if (this.minimumEntries > 1 && this.userPermissionConfig('edit')) {
      return `You need to upload at least ${this.minimumEntries
        } Resumes`
    }
    return ''
  }
  get isLoggedIn() {
    console.log('url', this.thisURL);
    return vxm.users.isLoggedIn;
  }

  get SelectedResume(): ResumeRecord {
    return this.selectedResume;
  }

  get thisURL() {
    return window.location.href.split('/')[
      window.location.href.split('/').length - 1
    ];
  }

  get ResumeListing(): ResumeWrapper {
    if (this.resumeListing && this.resumeListing.resumes && this.resumeListing.resumes.length > 0) {
      this.resumeAvailable = true;
    }
    return this.resumeListing;
  }

  selectResume(resume: ResumeRecord) {
    this.selectedResume = resume;
  }

  renameResume(resume: ResumeRecord) {
    if (resume) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('resume.label.renameresume'),
        );
      } else {
        this.currentResume = resume;
        this.currentResumeName = resume.name;
        this.$modal.show('rename-resume');
      }
    }
  }
  cancelRename() {
    this.$modal.hide('rename-resume');
  }

  async downloadResume(resume) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + resume.fileGUID;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download resume');
      }

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = resume.name;

      // Trigger a click event to initiate the download
      link.click();

      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }

  async selectFromDropbox() {
    const vm = this;
    vxm.users
      .uploadDropboxResume()
      .then(async (status) => {
        console.log('STATUS:', status);
        if (status === 'success') {
          vm.$wlToastr('success', vm.$t('SkillsDetails_SuccessfullyUploaded'), vm.$t('ResumeDetails_UploadResume'));
          const listPromise = await vxm.jobs.getResumeListing(
            vxm.users.getToken,
          );
          vm.resumeListing = vxm.jobs.resumeListing;
        } else {
          vm.$wlToastr('info', vm.$t('SkillsDetails_CancelUpload'), vm.$t('ResumeDetails_UploadResume'));
        }
      })
      .catch((err) => {
        vm.$wlToastr('error', vm.$t('ResumeDetails_UploadResumeError'), vm.$t('ResumeDetails_UploadResume'));
      });
  }

  async submitRename() {
    const vm = this;
    this.$modal.hide('rename-resume');
    this.currentResume.name = this.currentResumeName;
    const respPromise: any = vxm.users.renameResume(this.currentResume);
    const listPromise = vxm.jobs.getResumeListing(vxm.users.getToken);
    const [resp, list] = await Promise.all([respPromise, listPromise]);

    if (resp.success) {
      this.$wlToastr(
        'success',
        this.$t('resume-renamed-success'),
        this.$t('resume.label.renameresume'),
      );
      const token = vxm.users.getToken;
      vxm.jobs.getResumeListing(token).then(() => {
        this.resumeListing = vxm.jobs.resumeListing;
      });
    } else {
      this.$wlToastr(
        'error',
        resp.errorMessage,
        this.$t('resume.label.renameresume'),
      );
    }
  }

  async deleteResume(resume: ResumeRecord) {
    const vm = this;
    if (resume && resume.defaultResume !== true) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('ResumeDetails_DeleteResume'),
        );
      } else {
        const respPromise = vxm.users.deleteResume(resume);
        const listPromise = vxm.jobs.getResumeListing(vxm.users.getToken);
        const [resp, list] = await Promise.all([respPromise, listPromise]);

        if (resp.success) {
          this.$wlToastr('success', this.$t('resume-delete-success'), this.$t('ResumeDetails_DeleteResume'));
          const token = vxm.users.getToken;
          vxm.jobs.getResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
        } else {
          this.$wlToastr('error', resp.errorMessage, this.$t('ResumeDetails_DeleteResume'));
        }
      }
    } else {
      this.$wlToastr(
        'error',
        this.errorString,
        this.$t('ResumeDetails_DefaultResumeDeleteError'),
      );
    }
  }

  async defaultResume(resume: ResumeRecord) {
    const vm = this;
    if (resume) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('ResumeDetails_SetDefaultResume'),
        );
      } else {
        const respPromise = vxm.users.defaultResume(resume);
        const listPromise = respPromise.then(resp => {
          vxm.jobs.getResumeListing(vxm.users.getToken);
        })
        const [resp, list] = await Promise.all([respPromise, listPromise]);
        console.log(['in default resume', resp, list]);
        if (resp.success) {
          this.$wlToastr('success', resp.successMessage, this.$t('ResumeDetails_SetDefaultResume'));
          const token = vxm.users.getToken;
          vxm.jobs.getResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
        } else {
          this.$wlToastr('error', resp.errorMessage, this.$t('ResumeDetails_SetDefaultResume'));
        }
      }
    }
  }



  async uploadResume() {
    const vm = this;
    const token = vxm.users.getToken;
    this.resumePayload.accessToken = token;
    this.resumePayload.jobpostingid = -1;
    this.resumePayload.resumelink = '';
    console.log(this.resumePayload);

    if (this.validateFileSize(this.resumePayload.resumefile)) {
      if (this.validateUploadResume(this.resumePayload)) {
        try {
          const respPromise = vxm.jobs.postProfileResume(this.resumePayload);
          const [resp] = await Promise.all([respPromise]);
          if (resp.success) {
            vxm.users.Rudderstack.trackEvent("Resume Upload", {
              resumeName: this.resumePayload.resume.resumename
            });
            this.enableUploadResumeBtn = true;
            this.$wlToastr(
              'success',
              this.$t('profile.upload.resume.sucess'),
              this.$t('ResumeDetails_UploadResume'),
            );
            this.showUploadText = true;
            // tslint:disable-next-line:no-shadowed-variable
            const token = vxm.users.getToken;
            vxm.jobs.getResumeListing(token).then(() => {
              this.resumeListing = vxm.jobs.resumeListing;
            });
            vxm.users.getProfileStrength();
          } else if (resp.errorMessage) {
            this.$wlToastr(
              'error',
              this.$t('errorcode.2122').toString(),
              this.$t('ResumeDetails_UploadResume'),
            );

          } else {
            this.$wlToastr(
              'error',
              this.$t('profile.upload.resume.error'),
              this.$t('ResumeDetails_UploadResume'),
            );
          }
        } catch (e) {
          if (e && e.response && (e.response.status === 503 || e.response.status === 418)) {
            this.$wlToastr(
              'error',
              this.$t('ResumeDetails_SecurityRisk'),
            );
          }
        }
      } else {
        this.$wlToastr('error', this.$t(this.errorString), this.$t('ResumeDetails_UploadResume'));
      }
    }
    this.resumePayload.resumefile = '';
  }

  validateFileSize(file) {
    console.log('validating file size for file : ', file);
    if (file.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', { maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return false;
    }
    return true;
  }

  validateUploadResume(resumePayload: ResumePayload): boolean {
    if (!resumePayload.resume.resumename) {
      this.errorString = 'profile.upload.resume.file.required';
      return false;
    }
    if (resumePayload.resume.resumename.length > 250) {
      this.errorString = 'profile.resume.file.name.exceeded';
      return false;
    }

    return true;
  }
  validateFileFormate() {
    const vm = this;
    this.enableUploadResumeBtn = false;
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }

  validationFileFormatResume() {
    const vm = this;
    console.log([vm.resumePayload]);
    this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
    // if (this.resumePayload.resume.resumename.length > 250) {
    //   this.$wlToastr(
    //     'error',
    //     'You have exceeded the maximum character limit of 250 characters for file name',
    //     'Upload Resume',
    //   );
    //   return;
    // }

    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    // if (!allowedResumeFormat.includes(ext)) {
    //   this.$wlToastr(
    //     'error',
    //     fileNameFormat +
    //       ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`,
    //     'Upload Resume',
    //   );
    //   vm.resumePayload.resumefile = '';
    // }
  }

  mounted() {
    this.bus.$on('on-next-step', () => {
      this.$emit('go-to-next');
    });
    const token = vxm.users.getToken;
    vxm.jobs.getResumeListing(token).then(() => {
      this.resumeListing = vxm.jobs.resumeListing;
    });
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
  }
  get isConfigEnabled() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return true
    }
    return false
  }
  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  //new mthods
  toggleShowUploadText() {
    this.showUploadText = !this.showUploadText;
  }
  userPermissionConfig(permission) {
    return vxm.configs.getUserPermissionConfig(permission, 'RESUME');
  }
}
